import { render, staticRenderFns } from "./Picker.vue?vue&type=template&id=0681e025"
import script from "./Picker.vue?vue&type=script&setup=true&lang=js"
export * from "./Picker.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports